import { inject, Injectable } from "@angular/core";
import { PlatformType } from "src/app/common/platform-type";
import { UpdateService } from "src/app/services/update.service";
import { PLATFORM_TOKEN } from "src/app/tokens/platform.token";

@Injectable()
export class UpdateGuard {
  private readonly PLATFORM = inject(PLATFORM_TOKEN);
  private readonly updateService = inject(UpdateService);

  canActivate(): boolean {
    console.log("[UpdateGuard] canActivate");

    switch (this.PLATFORM) {
      case PlatformType.DESKTOP: {
        this.updateService.enableAutomaticUpdates();
        break;
      }
      case PlatformType.MOBILE: {
        this.updateService.enableAutomaticUpdates();
        break;
      }
    }

    return true;
  }
}
